import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
export function ProofSection() {
  return <AnimatedSection className="py-24 bg-navy-900 relative px-4 sm:px-6 lg:px-8" data-id="element-140">
      <div className="max-w-4xl mx-auto text-center" data-id="element-141">
        <div className="relative inline-block" data-id="element-142">
          <span className="absolute -top-8 -left-8 text-6xl text-gold-400/20 font-heading" data-id="element-143">
            "
          </span>
          <p className="text-2xl sm:text-3xl font-heading text-white leading-relaxed italic relative z-10" data-id="element-144">
            En los próximos 7 días, tras aplicar el Sistema de Inversión
            Invisible, sentirás por primera vez que tienes el{' '}
            <span className="text-gold-400 not-italic font-bold" data-id="element-145">
              control total de tu dinero
            </span>
            . Dejarás de sentir culpa al gastar en lo que te gusta, porque tu
            "yo del futuro" ya habrá cobrado su parte de forma automática.
          </p>
          <span className="absolute -bottom-8 -right-8 text-6xl text-gold-400/20 font-heading" data-id="element-146">
            "
          </span>
        </div>
      </div>

      {/* Bottom divider */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-400/10 to-transparent" data-id="element-147" />
    </AnimatedSection>;
}